import { ApolloClient, InMemoryCache } from "@apollo/client";

export const client = new ApolloClient({
  uri: "https://cms.paar.org.in/graphql",
  cache: new InMemoryCache(
    { addTypename: false }
  ),
});